import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import { bundlingUtils } from "./BundlingUtils";
import { SoundLoadConfig } from "./shared/UI/SoundManagerUtils";

import glowParticleUrl from "url:../assets/textures/glowParticle.webp";
import gameAtlasJsonUrl from "url:../assets/textures/gameAtlas.json";
import gameAtlasImageUrl from "url:../assets/textures/gameAtlas.webp";
import uiAtlasJsonUrl from "url:../assets/textures/uiAtlas.json";
import uiAtlasImageUrl from "url:../assets/textures/uiAtlas.webp";
import loadingAtlasJsonUrl from "url:../assets/textures/loadingAtlas.json";
import loadingAtlasImageUrl from "url:../assets/textures/loadingAtlas.webp";
import symbolAtlasJsonUrl from "url:../assets/textures/symbolAtlas.json";
import symbolAtlasImageUrl from "url:../assets/textures/symbolAtlas.webp";
import coinAtlasUrl from "url:../assets/textures/coin/coins.json";
import coinAtlasImageUrl from "url:../assets/textures/coin/coins.webp";
import mainBgUrl from "url:../assets/textures/mainBg.webp";
import fsBgUrl from "url:../assets/textures/fsBg.webp";
import winFontUrl from "url:../assets/fonts/winFont.fnt";
import winFontImageUrl from "url:../assets/fonts/winFont.png";
import multiplierFontUrl from "url:../assets/fonts/multiplierFont.fnt";
import multiplierFontImageUrl from "url:../assets/fonts/multiplierFont.webp";
import characterJsonUrl from "url:../assets/spine/aphrodite.json";
import characterAtlasUrl from "url:../assets/spine/aphrodite.atlas";
import characterAtlasImageUrl from "url:../assets/spine/aphrodite.webp";
import winsJsonUrl from "url:../assets/spine/wins.json";
import winsAtlasUrl from "url:../assets/spine/wins.atlas";
import winsAtlasImageUrl from "url:../assets/spine/wins.webp";
import h1JsonUrl from "url:../assets/spine/h1.json";
import h1AtlasUrl from "url:../assets/spine/h1.atlas";
import h1AtlasImageUrl from "url:../assets/spine/h1.webp";
import h2JsonUrl from "url:../assets/spine/h2.json";
import h2AtlasUrl from "url:../assets/spine/h2.atlas";
import h2AtlasImageUrl from "url:../assets/spine/h2.webp";
import h3JsonUrl from "url:../assets/spine/h3.json";
import h3AtlasUrl from "url:../assets/spine/h3.atlas";
import h3AtlasImageUrl from "url:../assets/spine/h3.webp";
import h4JsonUrl from "url:../assets/spine/h4.json";
import h4AtlasUrl from "url:../assets/spine/h4.atlas";
import h4AtlasImageUrl from "url:../assets/spine/h4.webp";
import lowJsonUrl from "url:../assets/spine/lows.json";
import lowAtlasUrl from "url:../assets/spine/lows.atlas";
import lowAtlasImageUrl from "url:../assets/spine/lows.webp";
import bonusJsonUrl from "url:../assets/spine/scatter.json";
import bonusAtlasUrl from "url:../assets/spine/scatter.atlas";
import bonusAtlasImageUrl from "url:../assets/spine/scatter.webp";
import gameLogoAtlasUrl from "url:../assets/spine/logo.atlas";
import gameLogoAtlasImageUrl from "url:../assets/spine/logo.webp";
import gameLogoAtlasJsonUrl from "url:../assets/spine/logo.json";
import cloudsFrontAtlasJsonUrl from "url:../assets/spine/clouds_front.json";
import cloudsFrontAtlasUrl from "url:../assets/spine/clouds_front.atlas";
import cloudsFrontAtlasImageUrl from "url:../assets/spine/clouds_front.webp";
import cloudsBackAtlasJsonUrl from "url:../assets/spine/clouds_back.json";
import cloudsBackAtlasUrl from "url:../assets/spine/clouds_back.atlas";
import cloudsBackAtlasImageUrl from "url:../assets/spine/clouds_back.webp";
import multiplierJsonUrl from "url:../assets/spine/multiplier.json";
import multiplierAtlasUrl from "url:../assets/spine/multiplier.atlas";
import multiplierAtlasImageUrl from "url:../assets/spine/multiplier.webp";
import anticJsonUrl from "url:../assets/spine/antic.json";
import anticAtlasUrl from "url:../assets/spine/antic.atlas";
import anticAtlasImageUrl from "url:../assets/spine/antic.webp";
import bigWinUrl from "url:../assets/audio/bigWin.m4a";
import bigWinEndUrl from "url:../assets/audio/bigWinEnd.m4a";
import buttonClickUrl from "url:../assets/audio/buttonClick.m4a";
import specialButtonClickUrl from "url:../assets/audio/specialButtonClick.m4a";
import freeSpinLoopUrl from "url:../assets/audio/freeSpinLoop.m4a";
import freeSpinPopupUrl from "url:../assets/audio/freeSpinPopup.m4a";
import musicMainLoopUrl from "url:../assets/audio/musicMainLoop.m4a";
import matchSymbolsUrl from "url:../assets/audio/matchSymbols.m4a";
import matchSymbolsOffUrl from "url:../assets/audio/matchSymbolsOff.m4a";
import megaWinUrl from "url:../assets/audio/megaWin.m4a";
import megaWinEndUrl from "url:../assets/audio/megaWinEnd.m4a";
import multiplierApplyUrl from "url:../assets/audio/multiplierApply.m4a";
import multiplierTriggerUrl from "url:../assets/audio/multiplierTrigger.m4a";
import reelLandUrl from "url:../assets/audio/reelLand.m4a";
import reelSpinUrl from "url:../assets/audio/reelSpin.m4a";
import startGameUrl from "url:../assets/audio/startGame.m4a";
import superWinUrl from "url:../assets/audio/superWin.m4a";
import superWinEndUrl from "url:../assets/audio/superWinEnd.m4a";
import totalWinPopupUrl from "url:../assets/audio/totalWinPopup.m4a";
import winUrl from "url:../assets/audio/winFinal.m4a";
import winProgressiveUrl from "url:../assets/audio/winProgressive.m4a";
import uiFontUrlUrl from "url:../assets/fonts/Roboto_Condensed-Regular.ttf";
import textFontUrl from "url:../assets/fonts/OleoScript-Regular.ttf";
import multipliersUrl from "url:../assets/Multipliers.jpg";
import betDemoUrl from "url:../assets/BetDemonstration.jpg";

import { GameAssets } from "./shared/util/GameAssets";
import { soundManager } from "./shared/UI/SoundManager";

class GameAssetManager {
    private static _instance: GameAssetManager;

    private _totalProgress = { textures: 0, skeletons: 0, audio: 0 };

    public static getInstance(): GameAssetManager {
        if (!this._instance) {
            this._instance = new GameAssetManager();
        }

        return this._instance;
    }

    public createGameAssetBundles(): void {
        Assets.addBundle("loading", {
            // introFillBar: introFillBarUrl,
            // introFillBg: introFillBgUrl,
            // logo: logoUrl,
            // logoBg: logoBgUrl,
            // contentFrame: contentFrameUrl,
            // content1: content1Url,
            // content2: content2Url,
            introBg: mainBgUrl,
        });

        // Texture assets
        Assets.addBundle("textures", {
            // logo: logoUrl,
            // fsCounter: fsCounterUrl,
            // panelFs: panelFsUrl,
            // panelMain: panelMainUrl,
            // panelMask: panelMaskUrl,
            // popup: popupUrl,
            // multiplierTotal: multiplierTotalUrl,

            fsBg: fsBgUrl,
            mainBg: mainBgUrl,
            glowParticle: glowParticleUrl,

            // appleSymbol: appleSymbolUrl,
            // blueStone: blueStoneUrl,
            // greenStone: greenStoneUrl,
            // mirrorSymbol: mirrorSymbolUrl,
            // pinkStone: pinkStoneUrl,
            // redStone: redStoneUrl,
            // roseSymbol: roseSymbolUrl,
            // scatterSymbol: scatterSymbolUrl,
            // swanSymbol: swanSymbolUrl,
            // yellowStone: yellowStoneUrl,

            multipliers: multipliersUrl,
            betDemo: betDemoUrl,
            // character: characterUrl,

            // fastButtonOn: fastButtonOnUrl,
            // fastButtonOff: fastButtonOffUrl,
            // spinButtonNew: spinButtonNewUrl,
            // stopButtonNew: stopButtonNewUrl,
            // buyButtonNew: buyButtonNewUrl,
            // betButtonNew: betButtonNewUrl,
            // bottomBarNew: bottomBarNewUrl,
            // bottomBarPortrait: bottomBarPortraitUrl,
            // autoplayButton: autoplayButtonUrl,
            // amountBackground: amountBackgroundUrl,
            // soundButtonOn: soundButtonOnUrl,
            // soundButtonOff: soundButtonOffUrl,
            // infoButton: infoButtonUrl,
        });

        // Spine assets
        Assets.addBundle("spines", {
            characterJson: characterJsonUrl,
            winsJson: winsJsonUrl,
            h1Json: h1JsonUrl,
            h2Json: h2JsonUrl,
            h3Json: h3JsonUrl,
            h4Json: h4JsonUrl,
            lowJson: lowJsonUrl,
            bonusJson: bonusJsonUrl,
            gameLogoJson: gameLogoAtlasJsonUrl,
            multiplierJson: multiplierJsonUrl,
            anticJson: anticJsonUrl,
            cloudsFrontJson: cloudsFrontAtlasJsonUrl,
            cloudsBackJson: cloudsBackAtlasJsonUrl
        });

        // Assets.addBundle("audio", {
        //     musicMainLoop: musicMainLoopUrl,
        //     bigWin: bigWinUrl,
        //     bigWinEnd: bigWinEndUrl,
        //     buttonClick: buttonClickUrl,
        //     countUp: countUpUrl,
        //     freeSpinLoop: freeSpinLoopUrl,
        //     freeSpinPopup: freeSpinPopupUrl,
        //     matchSymbols: matchSymbolsUrl,
        //     matchSymbolsOff: matchSymbolsOffUrl,
        //     megaWin: megaWinUrl,
        //     megaWinEnd: megaWinEndUrl,
        //     multiplierApply: multiplierApplyUrl,
        //     multiplierTrigger: multiplierTriggerUrl,
        //     reelLand: reelLandUrl,
        //     reelSpin: reelSpinUrl,
        //     startGame: startGameUrl,
        //     superWin: superWinUrl,
        //     superWinEnd: superWinEndUrl,
        //     totalWinPopup: totalWinPopupUrl,
        //     winFinal: winUrl,
        //     winProgressive: winProgressiveUrl,
        // });
    }

    /**
     * Load assets required for the loading screen.
     */
    public async loadLoadingScreenAssets() {
        await soundManager.createSound({ url: startGameUrl, key: "startGame" });
        const loadingAssets = await Assets.loadBundle("loading");

        // Add the spritesheet to loading assets
        loadingAssets.loadingAtlas = await bundlingUtils.createSpritesheet(
            loadingAtlasJsonUrl,
            loadingAtlasImageUrl,
        );

        GameAssets.loading = loadingAssets;
        // console.log(GameAssets.loading);
    }

    /**
      * Load custom fonts for the game.
      */
    public async loadFonts(): Promise<void> {
        const font = new FontFace("UIFont", `url(${uiFontUrlUrl})`);
        const textFont = new FontFace("TextFont", `url(${textFontUrl})`);

        try {
            await font.load();
            await textFont.load();
            document.fonts.add(font);
            document.fonts.add(textFont);
        } catch (err) {
            console.error("Failed to load fonts:", err);
        }
    }

    /**
     * Load game assets and track loading progress.
     */
    public async loadGameAssets(progressCallback?: (progress: number) => void, completeCallback?: () => void) {
        let customAssetsProgress: number = 0;

        const updateProgress = () => {
            const combinedProgress =
                (this._totalProgress.textures +
                    this._totalProgress.skeletons +
                    this._totalProgress.audio +
                    customAssetsProgress) /
                4;

            progressCallback?.(combinedProgress);
        };

        const textures = await Assets.loadBundle("textures", (progress) => {
            this._totalProgress.textures = progress;
            updateProgress();
        });

        const skeletons = await Assets.loadBundle("spines", (progress) => {
            this._totalProgress.skeletons = progress;
            updateProgress();
        });

        await this._loadSounds((progress: number) => {
            this._totalProgress.audio = progress;
            updateProgress();
        });

        await this._loadCustomAssets(textures, skeletons, (progress: number) => {
            customAssetsProgress = progress;
            updateProgress();
        });

        // Register ALL spine assets in PIXI's cache
        Object.keys(skeletons).forEach((key) => {
            PIXI.Assets.cache.set(key, skeletons[key]);
        });

        GameAssets.textures = textures;
        GameAssets.skeletons = skeletons;
        // TODO: Consider assigning loaded pixi audio objects here
        // GameAssets.audio = audio;
        // console.log(GameAssets.textures.uiAtlas);

        completeCallback?.();
    }

    private async _loadCustomAssets(
        textures: any,
        skeletons: any,
        callback: (progress: number) => void,
    ): Promise<void> {
        const assetDefs: { key: string, createFunction: () => Promise<any>, bundle: any }[] = [
            {
                key: "gameAtlas",
                createFunction: () => bundlingUtils.createSpritesheet(gameAtlasJsonUrl, gameAtlasImageUrl),
                bundle: textures,
            },
            {
                key: "uiAtlas",
                createFunction: () => bundlingUtils.createSpritesheet(uiAtlasJsonUrl, uiAtlasImageUrl),
                bundle: textures,
            },
            {
                key: "symbolAtlas",
                createFunction: () => bundlingUtils.createSpritesheet(symbolAtlasJsonUrl, symbolAtlasImageUrl),
                bundle: textures,
            },
            {
                key: "coinAtlas",
                createFunction: () => bundlingUtils.createSpritesheet(coinAtlasUrl, coinAtlasImageUrl),
                bundle: textures,
            },
            {
                key: "characterAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(characterAtlasUrl, characterAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "cloudsFrontAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(cloudsFrontAtlasUrl, cloudsFrontAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "cloudsBackAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(cloudsBackAtlasUrl, cloudsBackAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "winsAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(winsAtlasUrl, winsAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "h1Atlas",
                createFunction: () => bundlingUtils.createSpineAtlas(h1AtlasUrl, h1AtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "h2Atlas",
                createFunction: () => bundlingUtils.createSpineAtlas(h2AtlasUrl, h2AtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "h3Atlas",
                createFunction: () => bundlingUtils.createSpineAtlas(h3AtlasUrl, h3AtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "h4Atlas",
                createFunction: () => bundlingUtils.createSpineAtlas(h4AtlasUrl, h4AtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "lowAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(lowAtlasUrl, lowAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "bonusAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(bonusAtlasUrl, bonusAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "gameLogoAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(gameLogoAtlasUrl, gameLogoAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "multiplierAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(multiplierAtlasUrl, multiplierAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "anticAtlas",
                createFunction: () => bundlingUtils.createSpineAtlas(anticAtlasUrl, anticAtlasImageUrl),
                bundle: skeletons,
            },
            {
                key: "font",
                createFunction: () => bundlingUtils.createBitmapFont(winFontUrl, winFontImageUrl, "winFont"),
                bundle: null,
            },
            {
                key: "font",
                createFunction: () => bundlingUtils.createBitmapFont(multiplierFontUrl, multiplierFontImageUrl, "multiplierFont"),
                bundle: null,
            },
        ];

        const total: number = assetDefs.length;
        let completed: number = 0;

        const wrappedPromises = assetDefs.map((data) =>
            data.createFunction().then((result: any) => {
                if (data.bundle) {
                    data.bundle[data.key] = result;
                }
                completed++;
                callback(completed / total);
            }),
        );

        await Promise.all(wrappedPromises);
    }

    private async _loadSounds(
        callback: (progress: number) => void,
    ): Promise<void> {
        const soundDefs: SoundLoadConfig[] = [
            { url: bigWinUrl, key: "bigWin" },
            { url: bigWinEndUrl, key: "bigWinEnd" },
            { url: megaWinUrl, key: "megaWin" },
            { url: megaWinEndUrl, key: "megaWinEnd" },
            { url: superWinUrl, key: "superWin" },
            { url: superWinEndUrl, key: "superWinEnd" },
            { url: buttonClickUrl, key: "buttonClick" },
            { url: specialButtonClickUrl, key: "specialButtonClick" },
            { url: freeSpinPopupUrl, key: "freeSpinPopup" },
            { url: matchSymbolsUrl, key: "matchSymbols" },
            { url: matchSymbolsOffUrl, key: "matchSymbolsOff" },
            { url: multiplierTriggerUrl, key: "multiplierTrigger" },
            { url: multiplierApplyUrl, key: "multiplierApply" },
            { url: reelLandUrl, key: "reelLand" },
            { url: reelSpinUrl, key: "reelSpin" },
            { url: totalWinPopupUrl, key: "totalWinPopup" },
            { url: winUrl, key: "win" },
            { url: winProgressiveUrl, key: "winProgressive" },
            { url: freeSpinLoopUrl, key: "freeSpinLoop" },
            { url: musicMainLoopUrl, key: "musicMainLoop", loop: true },
        ];

        const total: number = soundDefs.length;
        let completed: number = 0;

        const wrappedPromises = soundDefs.map(
            (loadConfig: SoundLoadConfig) =>
                soundManager.createSound(loadConfig).then(() => {
                    completed++;
                    callback(completed / total);
                }),
        );

        await Promise.all(wrappedPromises);
    }
}

export const gameAssetManager = GameAssetManager.getInstance();
